import styled from 'styled-components'

export const ThumbnailImage = styled.img`
  max-height: 56px;
  max-width: 100%;
  position: relative;
`
